import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useGetRevenueGraph, useGetSubscriptionGraph } from "../../api/hooks/useDashboard";
import DashboardChart from "../../features/dashboard/components/DashboardChart";

function RevenueAnalytic() {
  const navigate = useNavigate();
  const [subscriptionRange, setSubscriptionRange] = useState(1); // 1=day, 2=week, 3=month, 4=year
  const [revenueRange, setRevenueRange] = useState(1);

  const { data: subscriptionData, isLoading: isLoadingSub } = useGetSubscriptionGraph({ type: subscriptionRange });
  const { data: revenueData, isLoading: isLoadingRev } = useGetRevenueGraph({ type: revenueRange });

  const formattedSubData = subscriptionData?.data?.map((item: any) => ({
    name: item.name,
    value: item.value || 0
  })) || [];

  const formattedRevData = revenueData?.data?.map((item: any) => ({
    name: item.name,
    value: item.value || 0
  })) || [];

  return (
    <>
      <div className="main_title">
        <h1>Revenue Analytics</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> - Revenue Analytics
        </p>
      </div>

      <div className="grid_sc gap_m">
        <DashboardChart
          title="Total Subscriptions"
          currentType={subscriptionRange}
          onTypeChange={setSubscriptionRange}
          isLoading={isLoadingSub}
          data={formattedSubData}
          barColor="#38B6FF"
          height={400}
          noDataMessage="No subscription data available"
        />

        <DashboardChart
          title="Total Revenue"
          currentType={revenueRange}
          onTypeChange={setRevenueRange}
          isLoading={isLoadingRev}
          data={formattedRevData}
          barColor="#FF8238"
          height={400}
          noDataMessage="No revenue data available"
        />
      </div>
    </>
  );
}

export default RevenueAnalytic;
